(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/utils/ticket-context.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/utils/ticket-context.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createContext,
  useContext,
  useMemo
} = React;
const TicketContext = createContext();
const ticketReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_TICKET_INFO':
      return _objectSpread(_objectSpread({}, state), {}, {
        ticketInfo: action.payload
      });
    default:
      return state;
  }
};
const TicketProvider = _ref => {
  let {
    children
  } = _ref;
  const [state, dispatch] = React.useReducer(ticketReducer, {
    ticketInfo: null
  });
  const value = useMemo(() => {
    const updateTicketInfo = newTicketInfo => {
      dispatch({
        type: 'UPDATE_TICKET_INFO',
        payload: newTicketInfo
      });
    };
    return {
      ticketInfo: state.ticketInfo,
      updateTicketInfo
    };
  }, [state.ticketInfo]);
  return React.createElement(TicketContext.Provider, {
    value: value
  }, children);
};
const useTicketContext = () => {
  const context = useContext(TicketContext);
  if (context === undefined) {
    throw new Error('useTicketContext must be used within a TicketProvider');
  }
  return context;
};
setGlobal('svs.tickets.play.utils.context', {
  TicketContext,
  TicketProvider,
  useTicketContext
});

 })(window);